import { models } from "./models";
import { providers } from "./providers";
import { catalogMeta } from "./meta";
import type { Model, Provider } from "../types";

export { models, providers, catalogMeta };

export function getProvider(id: string): Provider | undefined {
  return providers.find((p) => p.id === id);
}

export function getModel(id: string): Model | undefined {
  return models.find((m) => m.id === id);
}

export function getModelsByProvider(providerId: string): Model[] {
  return models.filter((m) => m.providerId === providerId);
}

export function providerModelCount(providerId: string): number {
  return models.filter((m) => m.providerId === providerId).length;
}

export const ALL_CAPABILITIES = Array.from(
  new Set(models.flatMap((m) => m.capabilities)),
).sort();
